export var RewardMessage;
(function (RewardMessage) {
    RewardMessage.TypeEnum = {
        SaveForOccasionUnlock: 'save_for_occasion_unlock',
        VoucherEarn: 'voucher_earn',
        AirnzBurn: 'airnz_burn',
        QantasBurn: 'qantas_burn',
        VoucherSaved: 'voucher_saved'
    };
})(RewardMessage || (RewardMessage = {}));
